import { Component, OnInit, OnDestroy, ViewChild, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, Params } from "@angular/router";
import { Observable } from 'rxjs/Rx';

import { BaseWebApiService, DialogsService, CommonJS, ResponseStatusCodes } from "angular-library";

import { DiretteService } from '../core/services/dirette.service';
import { TimeInfoService } from "app/core/services/time-info.service";
import { CronacaComponent } from '../cronaca/cronaca.component';
import { Dirette, dataEvento, TimeInfo } from '../shared/shared.module';

@Component({
    moduleId: module.id,
    selector: 'diretta-portale',
    templateUrl: 'diretta-portale.html'
})
export class DirettaPortaleComponent implements OnInit, OnDestroy, AfterViewChecked {

    diretta: Dirette = new Dirette();
    portale: string = null;
    parametri: dataEvento = null;
    basServiceSubscription: any;
    basServiceSubscriptionError: any;
    asyncWaiting: boolean = false;
    domainChecked: boolean = false;
    timer;
    timerSubscription;
    onlyMainEvents: boolean = false;
    selectedTab: number = 0;
    timeInfo: TimeInfo = new TimeInfo();
    dataMatch: string = null;
    showMarcatoriMobile: boolean = false;
    descrizioneMatch: string = null;
    lastSentHeight: number = null;
    firstLoad: boolean = true;
    @ViewChild("cronacaComponent") cronacaComponent: CronacaComponent;

    constructor(private diretteService: DiretteService,
        private route: ActivatedRoute,
        private baseService: BaseWebApiService,
        private dialogsService: DialogsService,
        private timeInfoService: TimeInfoService) {
        this.basServiceSubscription = this.baseService.isAsyncWaiting.subscribe(value => this.asyncWaiting = value);
        this.basServiceSubscriptionError = this.baseService.isAsyncError.subscribe(value => {
            if (value.isError) dialogsService.alert("Errore", value.message);
        });
    }

    ngOnInit(): void {
        /*if (document.domain == "localhost")*/ this.domainChecked = true;
        window.addEventListener("message", (event) => {
            this.receiveMessage(event);
        }, false);
        this.route.params.subscribe((data: Params) => {
            let d: dataEvento = data as dataEvento;
            this.parametri = new dataEvento();
            this.parametri.idDiretta = d.idDiretta;
            this.parametri.idEvento = d.idEvento;
            this.parametri.nuovoStato = d.nuovoStato;
            this.parametri.portale = d.portale;
            this.getDiretta();
        });
    }

    ngOnDestroy() {
        this.basServiceSubscription.unsubscribe();
        this.basServiceSubscriptionError.unsubscribe();
        this.timer = null;
        if (this.timerSubscription) this.timerSubscription.unsubscribe();
    }

    receiveMessage(event) {
        if (event.data == "checkdomain") {
            /*this.diretteService.checkPortale(event.origin).then((response) => {
                if (response.status == ResponseStatusCodes.OK) {
                    this.domainChecked = true;
                    this.getDiretta();
                }
            });*/
            this.getDiretta();
        }
    }

    getDiretta() {
        //if (this.domainChecked) {
            this.baseService
                .getClientIP()
                .then(ip => {
                    this.parametri.requestIP = ip;
                    this.diretteService.getDirettaPortale(this.parametri).then(
                        p => {
                            if (p.payload) {
                                this.loadData(p.payload);
                                this.firstLoad = false;
                            }
                        })
                })
        //}
    }

    refreshDiretta() {
        //if (this.domainChecked) {
            this.diretteService.refreshDirettaPortale(this.diretta).then(
                p => { if (p.payload) this.loadData(p.payload) }
            )
        //}
    }

    loadData(diretta: Dirette) {
        this.diretta = diretta;
        this.diretta.statiDirette.sort((a, b) => a.id - b.id);
        this.diretta.statoCorrente = this.diretta.statiDirette.find(x => x.id == this.diretta.stato);
        this.dataMatch = CommonJS.jsonToItalianDate(this.diretta.match.dataMatch).toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })
        this.descrizioneMatch = this.dataMatch;
        if (diretta.giornata || diretta.competizione) {
            this.descrizioneMatch += " - ";
            if (diretta.giornata) {
                this.descrizioneMatch += diretta.giornata;
                if (diretta.competizione) this.descrizioneMatch += " di " + diretta.competizione;
            } else this.descrizioneMatch += diretta.competizione;
        }
        this.timeInfo = this.timeInfoService.getTime(this.diretta);
        if (this.timer == null) {
            this.timer = Observable.timer(0, 5000);
            this.timerSubscription = this.timer.subscribe(() => { this.refreshDiretta(); });
        }
    }

    getImage(team: string): string {
        let image: string = team ? team.toLowerCase() : "empty";
        return "img/team/" + image + ".png";
    }

    selectTab(tabId: number) {
        this.selectedTab = tabId;
    }

    switchEvents(main: boolean) {
        this.onlyMainEvents = main;
        this.cronacaComponent.onlyMainEvents = this.onlyMainEvents;
        this.cronacaComponent.toggleEventi(main);
    }

    toggleMaractoriMobile() {
        this.showMarcatoriMobile = !this.showMarcatoriMobile;
    }

    ngAfterViewChecked(): void {
        try {
            let headerHeight: number = document.getElementById("diretta-header").scrollHeight;
            let contentHeight: number = document.getElementById("diretta-content").scrollHeight;
            let actualHeight: number = headerHeight + contentHeight;
            if (this.lastSentHeight != actualHeight) {
                this.lastSentHeight = actualHeight
                top.window.postMessage(actualHeight, "*");
            }
        } catch (error) { }
    }

    getAbbreviazione(nomeSquadra: string): string {
        let result: string = nomeSquadra;
        if (result && result.length > 15 && result.indexOf(" ") > -1) {
            let words: string[] = result.split(" ");
            words[words.length - 1] = words[words.length - 1].substr(0, 1) + ".";
            result = words.join(" ");
        }
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/diretta-portale/diretta-portale.component.ts